/*
 * Tutorials Messages
 *
 * This contains all the text for the Tutorials component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.SetupPage.components.Tutorials';

export default defineMessages({
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Title',
  },
  codeColumnLabel: {
    id: `${scope}.codeColumnLabel`,
    defaultMessage: 'Code',
  },
  titleEnColumnLabel: {
    id: `${scope}.titleEnColumnLabel`,
    defaultMessage: 'Title (en)',
  },
  titleDeColumnLabel: {
    id: `${scope}.titleDeColumnLabel`,
    defaultMessage: 'Title (de)',
  },
  kindColumnLabel: {
    id: `${scope}.kindColumnLabel`,
    defaultMessage: 'Type',
  },
  cohortColumnLabel: {
    id: `${scope}.cohortColumnLabel`,
    defaultMessage: 'Cohort',
  },
  deleteTooltip: {
    id: `${scope}.deleteTooltip`,
    defaultMessage: 'Delete',
  },
  deleteTutorialConfirmation: {
    id: `${scope}.deleteTutorialConfirmation`,
    defaultMessage: 'Are you sure you want to delete this tutorial?',
  },
});
